import { showView } from '../actions/publicActions';
import { onShowFullCompose } from 'owa-calendar-compose-form-store';
import { onReadingPaneLoaded } from 'owa-calendar-reading-pane-actions';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';
import { orchestrator } from 'satcheljs';
import { getGroupOrAccountFromItemId } from 'owa-calendar-forms-route-helpers';

export default function registerFormOnShowOrchestrators() {
    orchestrator(onShowFullCompose, actionMessage => {
        showView(
            'Compose',
            undefined /* itemId */,
            undefined /* account */,
            undefined /* group */,
            undefined /* iCalUId */,
            actionMessage.formId
        );
        setPopoutChildState(PopoutChildState.Ready);
    });

    // Deeplinks listen for the onLoaded action instead of onShow so that only the
    // deeplink loading spinner shows and we don't switch to a new one for forms
    orchestrator(onReadingPaneLoaded, actionMessage => {
        const { group, account } = getGroupOrAccountFromItemId(actionMessage.itemId);
        showView(
            'Read',
            actionMessage.itemId.Id,
            account,
            group,
            actionMessage.iCalUId,
            actionMessage.formId
        );
        setPopoutChildState(PopoutChildState.Ready);
    });
}
